"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Proprietaire_vue_1 = __importDefault(require("./Proprietaire.vue"));
var vue_select_1 = __importDefault(require("vue-select"));
var Models_1 = require("../Models");
var debounce_1 = require("debounce");
var shortid = require('shortid');
exports.default = {
    components: {
        Proprietaire: Proprietaire_vue_1.default,
        VSelect: vue_select_1.default
    },
    props: {
        value: {
            type: Object
        },
        commune: {
            type: Object
        },
        proprietaires: Array,
        i: Number
    },
    data: function () {
        var data = {
            parcelle: this.value || new Models_1.Parcelle(this.commune),
            parcellesOptions: [],
            voiesOptions: [],
            parcelleParVoie: false,
            currentAjaxRequest: null,
            identifier: null,
        };
        if (!data.parcelle.Identifier) {
            data.parcelle.Identifier = shortid.generate();
        }
        data.identifier = data.parcelle.Identifier;
        return data;
    },
    watch: {
        parcelle: function (val) {
            this.parcelle = val || new Models_1.Parcelle(this.commune);
        }
    },
    methods: {
        getAllProprietaires: function () {
            var _this = this;
            return this.proprietaires.filter(function (p) {
                // Pas les propriétaires qui sont deja des references
                return !p.References &&
                    // Pas les propriétaires deja dans la liste
                    !_this.parcelle.Proprietaires.find(function (prop) {
                        return prop.Identifier === p.Identifier || prop.References === p.Identifier;
                    });
            });
        },
        selectProprietaire: function ($event) {
            var prop = $event.target.value;
            this.parcelle.Proprietaires.push({
                References: prop
            });
            $event.target.selectedIndex = 0;
        },
        stopCurrentAjaxRequest: function () {
            if (this.currentAjaxRequest && this.currentAjaxRequest.readyState != 4) {
                this.currentAjaxRequest.abort();
            }
        },
        fetchParcelles: debounce_1.debounce(function (search, loading) {
            var _this = this;
            loading(true);
            this.stopCurrentAjaxRequest();
            var commune = this.commune;
            this.currentAjaxRequest = $.ajax({
                url: '/Cadastre/SearchParcelle',
                data: {
                    ccodep: commune.CCODEP,
                    ccodir: commune.CCODIR,
                    ccocom: commune.CCOCOM,
                    parVoie: this.parcelleParVoie,
                    keywords: search
                },
            }).done(function (d) {
                loading(false);
                return _this.parcellesOptions = d;
            });
        }, 500),
        fetchVoies: debounce_1.debounce(function (search, loading) {
            var _this = this;
            loading(true);
            this.stopCurrentAjaxRequest();
            var commune = this.commune;
            this.currentAjaxRequest = $.ajax({
                url: '/Cadastre/SearchVoie',
                data: {
                    ccodep: commune.CCODEP,
                    ccodir: commune.CCODIR,
                    ccocom: commune.CCOCOM,
                    keywords: search
                },
            }).done(function (d) {
                loading(false);
                return _this.voiesOptions = d;
            });
        }, 500),
        onSelectVoie: function (value) {
            var numero = this.parcelle.DNUVOI;
            this.parcelle = value;
            this.parcelle.DNUVOI = numero;
            this.emitInput();
        },
        appendProprietaire: function () {
            if (!this.parcelle.Proprietaires) {
                this.parcelle.Proprietaires = [];
            }
            this.parcelle.Proprietaires.push(new Models_1.Proprietaire());
        },
        removeProprietaire: function (i) {
            var removedList = this.parcelle.Proprietaires.splice(i, 1);
            var removed = removedList[0];
            // On supprime les references aussi
            this.$emit("remove-proprietaire", removed);
        },
        resetParcelleOptions: function (parcelle) {
            parcelle.DomainePublic = false;
            parcelle.Introuvable = false;
        },
        emitInput: function (event) {
            var _this = this;
            // Génération des identifiants
            this.parcelle.Proprietaires.forEach(function (p) {
                // Ca veut dire que ecla provient v-select de parcelle
                if (event === 'select') {
                    // On cherche si on a deja des propriétaires avec le meme identifiant et on le rattache
                    var prop = _this.proprietaires.find(function (_) { return !_.References && _ !== p && _.Identifier === p.Identifier; });
                    if (prop) {
                        p.References = p.Identifier;
                        p.Identifier = null;
                        return;
                    }
                }
                if (p.References) {
                    return;
                }
                return p.Identifier = p.Identifier || shortid.generate();
            });
            this.parcelle.Identifier = this.identifier;
            this.$emit("input", this.parcelle);
        },
        numeroInsse: function (option) {
            // Si CCOPRE est null ou ne contient que des espaces on renvoit le numeroInsee de la commune
            if (option.CCOPRE == null || option.CCOPRE.trim().length === 0) {
                return option.CCODEP + " " + option.CCOCOM + " ";
            }
            //Sinon on renvoit le code Insse de la commune partagée
            else {
                return option.CCODEP + " " + option.CCOPRE + " ";
            }
        },
    },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/Parcelle.vue
// module id = 231
// module chunks = 0